import { useState, useEffect } from 'react'

import { getBranchList } from '@user/store/branches/api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'

export const useGetBranchListOnMount = () => {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getBranchList())

        if (mounted) {
          if (getBranchList.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error(`Error loading branch list: ${result.payload}`)
          }
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
